import { render } from "./BanCodePrint.vue?vue&type=template&id=1a87a986&scoped=true"
import script from "./BanCodePrint.vue?vue&type=script&lang=js"
export * from "./BanCodePrint.vue?vue&type=script&lang=js"

import "./BanCodePrint.vue?vue&type=style&index=0&id=1a87a986&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a87a986"]])

export default __exports__